import { Text, VStack } from '@chakra-ui/react'
import { ScreenContext } from '@hb/react'
import { ActionButton, PageContainer, useNavigate } from '@hb/react-web'
import { useContext, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router'
import { RecoverEmailView } from './RecoverEmailView'
import { ResetPasswordView } from './ResetPasswordView'
import { RevokeMultiFactorView } from './RevokeMultiFactorView'
import { VerifyEmailView } from './VerifyEmailView'

type ActionMode = 'resetPassword' | 'recoverEmail' | 'verifyEmail' | 'revertSecondFactorAddition'

export const AuthActionsView = () => {
  const { contentWidth } = useContext(ScreenContext)
  const [searchParams] = useSearchParams()
  const [mode, setMode] = useState<ActionMode | ''>(searchParams.get('mode') as ActionMode | '')
  const [oobCode, setOobCode] = useState(searchParams.get('oobCode') || '')
  const navigate = useNavigate()

  useEffect(() => {
    setMode(searchParams.get('mode') as ActionMode | '')
    setOobCode(searchParams.get('oobCode') || '')
  }, [searchParams])

  useEffect(() => {
    if (!mode || !oobCode) {
      navigate('/')
      return
    }
  }, [mode, oobCode, navigate])

  const renderContent = () => {
    if (!oobCode) return null

    switch (mode) {
      case 'resetPassword':
        return <ResetPasswordView oobCode={oobCode} />

      case 'recoverEmail':
        return <RecoverEmailView oobCode={oobCode} />

      case 'verifyEmail':
        return <VerifyEmailView oobCode={oobCode} />

      case 'revertSecondFactorAddition':
        return <RevokeMultiFactorView oobCode={oobCode} />

      default:
        return (
          <PageContainer>
            <VStack
              flexDir="column"
              w="100%"
              width={contentWidth}
              bg="gray.50"
              py={4}
              px={6}
              alignItems="flex-start"
              spacing={0}>
              <Text fontFamily="Hero-New" fontSize="xl" fontWeight={500} color="gray.600">
                Invalid Action
              </Text>
              <Text fontSize="lg">The action you requested is not recognized.</Text>
              <ActionButton onClick={() => navigate('/')} mt={3}>
                Go Home
              </ActionButton>
            </VStack>
          </PageContainer>
        )
    }
  }

  return <>{renderContent()}</>
}
